import { render } from "./StatisticsPage.vue?vue&type=template&id=00bd7cc7&scoped=true"
import script from "./Statistics.js?vue&type=script&lang=js&external"
export * from "./Statistics.js?vue&type=script&lang=js&external"

import "./StatisticsPage.vue?vue&type=style&index=0&id=00bd7cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bd7cc7"]])

export default __exports__